var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2057_50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "#ECF9FF",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2057_50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 27,
    height: 27,
    rx: 10,
    fill: "#7D89FF",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 41,
    height: 41,
    fill: "url(#pattern0_2057_50)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2057_50",
    x: 6,
    y: 15,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_2057_50"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2057_50",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2057_50",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2057_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2057_50",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAACoxJREFUeAHtXHuM3EYZv/J+gxAvFcQfFChv/kCg8pIoISEhuxeodE2Vy+2M95JrSHOES9tcE8+4TqKW83zeSxUaCiQgKCAKQkUg5e6qViDSSm2FRCVeTWml0tAiiqAlJG1Jac5kvOc7r9f2eDxj7znsSivbM9983+/3zcPz9MBA/9f3QN8DfQ/0PdD3gIIHvJn6Km927WFvpnbMm6mfav9rx7zZ+iEep6C6p0mXPS/vtvq7vNm1d3mzdU/wv5PL9tSbEsYrwcubG7zYm6n9S+D4pYzhsnODF0v4oSeileDllxAZ5wc1ZK725HKuCZXhlbHZWSr9QQb419rdnjdwXk+Kt8BoJXi1X0zCNj/B+QvpluGLuTK8vLnatzK3+x0lvyPTDgkKY+nRleHldzWTHZte8oN0M7VjpXtYYLAyvLyZ2knlGjBTOynwR+nRleGlBehs/UTpHhYYrAyvylRVgcOj0ZXh5U85BG153utc7ZtRB/T6uTK8KtNdk8zRSvHyZuq/zP0iPjJ4VNI3pYlXhpc/ZOfTCrJNkJ9m8MLSPCppqFK8pCetuPPPxcm4XvLyS8xs/U5hTTgyeNSbXb4lP1pRKsdr4QV2yDtSv39xQYbfnxMLMvVzjle0wPWf+x7oe6Dvgb4HKuYB27Zf0CCtGqJwK6LOXxGFZxFlHqaw+EcEzmDCTjQoHEMUvocpazZt5/zlShXb7E2YMoyJezOm7H6O3ecQ5kSZ1+YKj2EKPxkhrc8NDf34+aVxGhv7xgsxcccxZf8MOzvrPaLsWWzB17G9/zWlgRYYau50Xokt9wAmcDorj0459g9M3a3cNwJTatFN4lxoWPDHTuNLJV4unD06to9doIZIPfUm23kLMuFBOezxnJHl/r5ht96pjipGQ9N0P4EInNQBNNDBa8PoHmdFjLlSgjba8ClE2H8CPDquiMK/GxQ+qpUAptPvxwSe0gEwRsdpXgq1As6grGFOvxnlbnLia0DADRH2FKJT780AQywyZNsvwgQeCpQXcTUoOz4+fuDFYjR6JPhLE1P34SK4BDp5s8Z9p4wY72Y3BEqLvCI6dasy2IwKDAo/KJJLSHcrI6R4Md5lxLwrGeqGFXmPKFwaj0Rf6KgJ9SI5hHUjE87wrm1u9NhkN4UVFn2PKHtaCbCA6bB94FW6OxIinyDCbhTAio9u9/fZMyID2uMtdnc8IvVQbLI7tOMVtg7s6VzjA2Q5K8oH2+5dGNTZpu7uTg1N0xnuFZ+m5cjvCscEbu4VYD4i5d3EThfmf/KbHt68CUtrevcyb3pE4NvS6BuU/TmvQS3pLHaPNOiEBMhyf6EFU94MNNnDCdCSgxHpXYlZclarmYwwWwy2nc8v6SumhIv084FZNrQhqegsoMhIEfF8mmBoYvq1IVhSt9i2X4IpO1UENhmd3JdSwLmwjIFiZZ0fSoNfSGCYMFcstuw1SppDKcAJPCe2w06N2tNvlyVg2O57MIEM3WiWAUN2RyfxkcVfUg1gjyICf08CvRhO4C6ZRQ++WIQs+PVi+oSXJyLwGP+L5HTEL8sMMKjzG0zcbC9JAldnJYEpu07sNDbfsNw1mMB9YtlztAYgCrdzp2LCvi92AnsOW2Dbtv28tIwwKGxDBP4r1Ge5/hRBWaPjNMyxcUICCdVaKh1xb+HGxyanXo0JPJIprcnu2LT7hjdGQV+2bef5l1yx614cWZdO0PnQVvvgK7gOgzo/SpBZXNvWER/FK3zWYVSow4SDAZAmgc9gyuaFaSh4iMBfDLP1sSDtJVdc9YXVjS2nV27Y5A2OTXiIdG4OCOv0a4fZuihIiyz4Wji+qPvAXuZrUUA69FqwNwwIW+6NHfEptcx3JIHJwc07Dq8a3uxx5wf/tca41zCd2BKMKNsXtsmfs9pUkQvbzHSvYixzWuJuD4MZs+2XYeo8kDk9Be/SL1MvmgF+Tdg80Z0BBO6LrlJh4m6XsZdXNswz031eQzLpkOUOR8Fgs3URonIL5Rsnr/PW4K2LNSCoCRuu3ruYCVznqA3vi9ozKGyUwZxXNmpX+JzXkFQ6wlbHAUHU/RCmcuvQjd1T3hrUmQnrLt/hZwB/Z2DKPhlny++KpjR1UnxS9MTZTg3TZThdj/vhJBB8ChkT95b09J398/UTVkctWN3Ywnex3R7XawrsNkznIzI28soG9jJf8xqSSde0979NBMggcDnOOJfPez8rN7RfyJ9tbJkf2m5+dWDAS/0wCCLsAhnMeWVFPLvi8xqSScf7/12GYwIaNnzA36uZUsW53XYGbPLWNsefWX/lnjUxqrqC/DGIQK8MpyTZLsOigCRFusL5rjhR6Qxj5AMn0SrdZTuu9daN7XhwaPz614fTpt975/n7VQvOhHQMMbG6HJ2kB1H2txizwiBkwS5MoWvAhgg7s/5Ki8lkamAME/Z4Ek5d4YGtzFddhpP0IMr+kBlMRBDtaa1oEHYcE3/kPI8oHB++Zl/ujwMaVNeG485OQZh7hIL4EVtsCFN4IqxE673l/EqMohwJROCoVm7h5oywE9hyR3IxGbl26q1FgTMolLYVUUQeU/bTQjKAsHvyLCZ14PU3shKY1P2iQpQtm69mYeIc1psB/tT5VK4NWR3eDz3wAYuugww+WQumQup7emtQ19GVAe3tPPGjbmWSiLKGLqBnzxtkXuFSBi5QcHZP6k5tvPK29wKMfjS2dO4sZsp7frJgziKDLBjVlQEGYbUsNnPJ8AktXUARaQ3mAlFAIsOCdbp48aNcBUBsq+TTubqAIso+XhhQScXcafp4aTqaFMeBn+XSBRTb7rL5mPcIcd6ti5fOTcVdeTByFbxcF1Bjl8x8TRcUrQEjNrxBFy++qqcVXFRZ/sPM4WE6m+ebp6K6e/XMsWTdEJCaUQROF84B0Qw72cJD8fj7JwoHKmkAE/ZkqnPjeSwuefppCXtc0qy8OKLwJ1WgfEAnb7nYFLJLoPE+cB4oFiXfxWa598YbDzcxgnui7/CFLsKV4YUp3KaaAQ0KR3Q5TpcegzozqrywCXO68CTqkV0ojyNlUPhuooEeRYhW2+J4dIflP8uQmbb/qZksL6QUGWSx6cwGSxLEFPZ3O1TQlEY5muymwuFi6n5FFejZbYVm4UAlDRjUJcq8LLhe0qy8OKbsGlWgmLpb5C0Xm8Ig7IvKvAhMFouSb+f29+lIVs1oVbXYUOFAJQ3w71SoZgCi7pikWXlxw2LrVYEaBD4tb7nYFByTKq8yPjYygAhbpQqUb7Qq1p3y2pu09UFVXthyV8pblkyhYy9loTOGknwCcT0zvcl7XQM7yldM2DtUS8rQxPRLlYFoVsAxqfJS3gGRhROfRlYDyk5lsdMLGaT4Xbwx231d4bj97whFezUyzwQeKRxkTgOIsuMqhUvrNpQ0DirfX+Bng9N09zJO5cww/xJXadjbJ07yjQWCs8GlgZUwpHJmmNceCVNqooiw3+Wuqgtng9UQFJNa5cwwouy3xaCK0aq0X3ThhHqM2p4HYRMO5i5YZW42RpT9PC9Qg7I9Pfd0AgBswV4FXj9LUKs/mM/n5wWKKHxJPyI9GpXODBP4jh4UfS19D/Q90PdA3wN9D/Q90PfA/4MH/gd9j/EHHFhJ0QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesClient);
export default __webpack_public_path__ + "static/media/Sales-Client.b9a12845adb4f273439ceaea8b3729fc.svg";
export { ForwardRef as ReactComponent };